import React, { useCallback } from 'react';

import { Box, Typography } from '@mui/material';
import StatusIconCDS from 'app/shared/componentsRestyled/coreDesignSystem/StatusIconCDS';
import PropTypes from 'prop-types';

import { STEP_NODE_STATUS, STEP_NODE_STATUS_LABEL } from '../PathToSubmission.constants';
import { PathToSubmissionTestIds } from '../PathToSubmission.testIds';

import { NODE_STATUS_ICON } from './StepNode.constants';
import {
  getConnectorStyles,
  getNodeStyles,
  getStatusLabelStyles,
  labelStyles,
  stepWrapperStyles,
} from './StepNode.styles';

const StepNode = ({ stepKey, index, label, nodeStatus, isFirst, isConnectorDone, onSelect }) => {
  const statusIconType = NODE_STATUS_ICON[nodeStatus];

  const onClick = useCallback(() => onSelect(stepKey), [onSelect, stepKey]);

  return (
    <Box
      data-testid={PathToSubmissionTestIds.getStepNodeId(stepKey)}
      sx={stepWrapperStyles}
      onClick={onClick}
    >
      {!isFirst && <Box sx={getConnectorStyles(isConnectorDone)} />}
      <Box sx={getNodeStyles(nodeStatus)}>
        {statusIconType ? (
          <StatusIconCDS size={34} type={statusIconType} />
        ) : (
          <Typography variant="bold14">{index}</Typography>
        )}
      </Box>
      <Typography sx={labelStyles} variant="medium12">
        {label}
      </Typography>
      <Typography sx={getStatusLabelStyles(nodeStatus)} variant="bold12">
        {STEP_NODE_STATUS_LABEL[nodeStatus]}
      </Typography>
    </Box>
  );
};

StepNode.propTypes = {
  stepKey: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  label: PropTypes.string.isRequired,
  nodeStatus: PropTypes.oneOf(Object.values(STEP_NODE_STATUS)).isRequired,
  onSelect: PropTypes.func.isRequired,
  isFirst: PropTypes.bool,
  isConnectorDone: PropTypes.bool,
};

export default StepNode;
